import React, { useState, useEffect } from "react";
import { DirtyStateContext } from "@/contexts/dirtyStateContextDef";

export function DirtyStateProvider({ children }: { children: React.ReactNode }) {
  const [isDirty, setDirty] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = ""; // Legacy way required by some browsers
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isDirty]);

  const confirmNavigation = () => {
    if (isDirty) {
      const ok = window.confirm("You have unsaved changes. Are you sure you want to discard them?");
      if (ok) {
        setDirty(false);
      }
      return ok;
    }
    return true;
  };

  return (
    <DirtyStateContext.Provider value={{ isDirty, setDirty, confirmNavigation }}>
      {children}
    </DirtyStateContext.Provider>
  );
}
